@if (creatorId()) {
  <admin-user-profile [userId]="creatorId()!" />
}
